import useModal from "@/src-refactor/modules/shared/components/refactor/base/modal/useModal";
import { HCatchServerError } from "@/src-refactor/modules/shared/components/refactor/helpers/cath-error-server";
import { useLazyCheckConflictsQuery } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import HCheckArray from "@rf-helper/check-have-value";
import PropertyConflictCheckerTemplate from "./PropertyConflictCheckerTemplate";
import { PropertyConflictListAdapter } from "../../../../../adapters/conflict-list-property-adapter";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";

interface IInformationToCheck {
  sectorId: string;
  cityId: string;
  ownersId: string[] | string[];
  propertyTypeId?: string;
  projectTypeId?: string;
  propertyIdToIgnore: string | number;
}
const usePropertyConflictCheckerModal = () => {
  const { modal } = useModal();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const [CheckConflicts] = useLazyCheckConflictsQuery({});

  const handleConflictCheckerPropertyModal = (arg: IInformationToCheck) => {
    if (!HCheckArray(arg.ownersId)) return new Promise(() => {});
    const request = CheckConflicts({
      query: {
        sector_id: arg.sectorId,
        realstatetype_id: arg.propertyTypeId,
        owners: arg.ownersId,
        projecttype_id: arg.projectTypeId,
        realestateToIgnore: arg.propertyIdToIgnore
      }
    }).unwrap();

    return toast
      .promise(request, {
        error: e => HCatchServerError(e),
        loading: "Verificando conflictos",
        success: "Verificación completada"
      })
      .then(e => {
        e.data.length > 0 && handleModal(e);
      })
      .catch(e => console.log(e));
  };

  const handleModal = async (e: any) => {
    return modal({
      template: <MxModalTemplate2 children={<PropertyConflictCheckerTemplate />} />,
      data: PropertyConflictListAdapter(e),
      options: {
        title: "Conflicto de propiedades",
        disableCloseButton: false,
        size: {
          xs: {
            width: "100%",
            maxWidth: "430px"
          },
          sm: {
            width: "100%",
            maxWidth: "1000px",
            minWidth: "400px"
          },
          md: {
            width: "100%",
            maxWidth: "1000px",
            minWidth: "400px"
          },
          lg: {
            width: "100%",
            maxWidth: "1000px",
            minWidth: "400px"
          },
          xl: {
            width: "100%",
            maxWidth: "1000px",
            minWidth: "400px"
          }
        }
      }
    }).then(x => {
      if (x.type.close) {
        if (id) {
          navigate(C_PATH_ROUTES.REALESTATE.DETAIL(Number(id)));
        } else {
          navigate(C_PATH_ROUTES.REALESTATE.LIST);
        }
      }
    });
  };
  return { handleConflictCheckerPropertyModal };
};

export default usePropertyConflictCheckerModal;
